import {
    LocalOfferOutlined,
    MonetizationOnOutlined,
    SpaOutlined
} from '@mui/icons-material';
import DocPageLayout from './DocPageLayout.js';
import './DocPage.css';

const heroImage = '/img/full-body-balance.webp';
const secondaryImage = '/img/nerve-therapy-trial.webp';

const menuItems = [
    {
        title: '整体施術',
        time: '初回 50分 / 2回目以降 25分',
        price: '7,000円 (税別)',
        description: 'お試し・メンテナンス向けの施術コース'
    },
    {
        title: '鍼灸施術',
        time: '初回 50分 / 2回目以降 25分',
        price: '7,000円 (税別)',
        description: '鍼や灸による自律神経ケアと自然治癒力の活性化'
    },
    {
        title: '鍼灸＋整体施術 / 整体施術50分',
        time: '初回 75分 / 2回目以降 50分',
        price: '10,000円 (税別)',
        description: 'じっくり体を整えたい方におすすめ'
    },
    {
        title: '鍼灸＋整体施術 / 整体施術75分',
        time: '初回 100分 / 2回目以降 75分',
        price: '15,000円 (税別)',
        description: '深層の不調にアプローチする特別コース'
    },
    {
        title: '産後整体・骨盤矯正',
        time: '初回 75分 / 2回目以降 50分',
        price: '10,000円 (税別)',
        description: '産後の骨盤ケアと体調回復をサポート'
    },
    {
        title: '小顔施術 (小顔整体＋美容鍼)',
        time: '初回 100分 / 2回目以降 75分',
        price: '18,000円 (税別)',
        description: 'フェイスラインの引き締めとリフトアップに'
    }
];

const ticketInfo = [
    {
        title: '整体施術 / 鍼灸施術',
        tickets: ['10回 65,000円【1回 6,500円】(税別)']
    },
    {
        title: '鍼灸＋整体施術 / 整体施術50分',
        tickets: ['5回 47,500円【1回 9,500円】(税別)', '10回 90,000円【1回 9,000円】(税別)']
    },
    {
        title: '鍼灸＋整体施術 / 整体施術75分',
        tickets: ['5回 90,000円【1回 14,000円】(税別)', '10回 135,000円【1回 13,500円】(税別)']
    },
    {
        title: '産後整体・骨盤矯正',
        tickets: ['5回 47,500円【1回 9,500円】(税別)', '10回 90,000円【1回 9,000円】(税別)']
    },
    {
        title: '小顔施術',
        tickets: ['5回 85,000円【1回 16,500円】(税別)', '10回 160,000円【1回 16,000円】(税別)']
    }
];

const optionItems = [
    { title: '整体時間延長', time: '25分', price: '5,000円 (税別)' },
    { title: 'カッピング', time: '25分', price: '6,000円 (税別)' },
    { title: '筋膜リリース', time: '25分', price: '6,000円 (税別)' },
    { title: '痩身 (一部位)', time: '50分', price: '12,000円 (税別)' }
];

const MenuPage = () => (
    <DocPageLayout
        currentRoute="/menu"
        pageLabel="MENU"
        pageTitle="目的に合わせて選べる施術メニュー"
        heroImage={heroImage}
        heroImageAlt="全身バランス調整の様子"
        heroHighlight="整体・鍼灸・美容まで幅広く対応"
        heroDescription="身体の状態やライフスタイルに合わせて最適なプランをご提案します。"
    >
        <article className="doc-section">
            <h3 className="doc-section__title">
                <SpaOutlined className="doc-section__icon" />メニュー一覧
            </h3>
            <div className="doc-section__body">
                <div className="doc-list">
                    {menuItems.map(({ title, time, price, description }) => (
                        <li key={title}>
                            <SpaOutlined className="doc-list__icon" />
                            <span className="doc-list__content">
                                <strong>{title}</strong>
                                <span>{description}</span>
                                <span>目安時間：{time}</span>
                                <span>料金：{price}</span>
                            </span>
                        </li>
                    ))}
                </div>
                <div className="doc-section__media">
                    <img src={secondaryImage} alt="施術メニューのイメージ" loading="lazy" />
                </div>
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <MonetizationOnOutlined className="doc-section__icon" />お得な回数券
            </h3>
            <div className="doc-list">
                    {ticketInfo.map(({ title, tickets }) => (
                        <li key={title}>
                            <MonetizationOnOutlined className="doc-list__icon" />
                            <span className="doc-list__content">
                                <strong>{title}</strong>
                                {tickets.map((ticket) => (
                                    <span key={ticket}>{ticket}</span>
                                ))}
                            </span>
                        </li>
                    ))}
            </div>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">
                <LocalOfferOutlined className="doc-section__icon" />オプションメニュー
            </h3>
            <div className="doc-list">
                {optionItems.map(({ title, time, price }) => (
                    <li key={title}>
                        <LocalOfferOutlined className="doc-list__icon" />
                        <span className="doc-list__content">
                            <strong>{title}</strong>
                            <span>目安時間：{time}</span>
                            <span>料金：{price}</span>
                        </span>
                    </li>
                ))}
            </div>
            <p className="doc-note">※オプション単体の場合は＋2,000円となります。</p>
            <p className="doc-note">※施術内容と時間は目安です。余裕を持ったご予約にご協力ください。</p>
        </article>

        <article className="doc-section">
            <h3 className="doc-section__title">その他</h3>
            <div className="doc-section__body">
                <p>
                    整体は神経整体をメインに行います。表示料金は全て税別価格です。お身体の状態に合わせて施術内容をご相談の上で決定いたします。
                </p>
                <p className="doc-note">キャンペーンもございますので、お気軽にお問い合わせください。</p>
            </div>
        </article>
    </DocPageLayout>
);

export default MenuPage;

